module.exports = __webpack_public_path__ + "static/media/paint.350e3e9b.svg";